<template>
  <v-dialog v-model="dialogVisible" max-width="450" persistent :scrim="true">
    <v-card class="gm-dialog-card" rounded="lg">
      <v-card-title class="pb-0">
        <div class="d-flex align-center ga-3">
          <span class="text-h6">{{ $str.getKey('全局/系统提示') }}</span>
        </div>
      </v-card-title>

      <v-card-text>
        <div class="text-body-1" style="word-break: break-word;">
          {{ $str.getKey('全局/登录状态已过期，请重新登录') }}
        </div>
      </v-card-text>

      <v-card-actions class="justify-end pt-2 pb-4">
        <v-btn color="primary" variant="flat" @click="handleConfirm">
          {{ $str.getKey('全局/重新登录') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import useUserStore from '@/store/modules/user'
import { registerReloginCallback, getReloginShowing, setReloginShowing } from '@/utils/request/relogin'

const dialogVisible = ref(false)
let onConfirmCallback = null

const handleConfirm = () => {
  dialogVisible.value = false
  if (onConfirmCallback) {
    onConfirmCallback()
  }
  setReloginShowing(false)
}

onMounted(() => {
  registerReloginCallback(() => {
    dialogVisible.value = true
    onConfirmCallback = () => {
      useUserStore().logOutWithoutAPI().then(() => {
        location.href = '/index'
      })
    }
  })

  // 防止刷新后已经在显示状态
  if (getReloginShowing()) {
    dialogVisible.value = true
    onConfirmCallback = () => {
      useUserStore().logOutWithoutAPI().then(() => {
        location.href = '/index'
      })
    }
  }
})
</script>

<style scoped>
.gm-dialog-card {
  border-radius: 16px;
}
</style>